<script setup lang="ts">
import { computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const { Textarea: PocketTextarea } = UIKit

const props = withDefaults(defineProps<{
    label?: string
    modelValue: string
    height: string
    width?: string
    disabled: boolean
    isDarkMode: boolean
    showIconAndTooltip?: boolean
}>(), {
    width: '100%',
    label: '',
})

const emit = defineEmits<{
    'update:modelValue': [value: string]
}>()

const tooltipText = computed(() => {
    return `Explaining your answer helps you think critically as you prepare for your exam.
        Compare your explanation to Pocket Prep's rationale.`
})

const updateModelValue = (newVal: string) => {
    emit('update:modelValue', newVal)
}
</script>

<template>
    <PocketTextarea
        class="bonus-question-textarea"
        :class="{
            'bonus-question-textarea--disabled': disabled,
        }"
        :modelValue="modelValue"
        :label="props.label"
        :height="props.height"
        :width="props.width"
        :disabled="props.disabled"
        :is-dark-mode="props.isDarkMode"
        :show-icon-and-tooltip="props.showIconAndTooltip"
        :tooltip-text="tooltipText"
        @update:modelValue="updateModelValue"
        @keydown.stop
    />
</template>

<style lang="scss" scoped>
.bonus-question-textarea {
    margin: 0 auto;
    max-width: 492px;

    :deep(.uikit-textarea__label) {
        margin-left: 15px;
    }

    :deep(.uikit-textarea__textarea) {
        width: 341px;
        resize: none;
        padding: 11px 15px;

        &:disabled {
            background-color: rgba($white, 0.4);
            border: 1px solid rgba($pewter, 0.5);
        }

        @include breakpoint(brown-bear) {
            width: 100%;
        }
    }

    :deep(.uikit-textarea__textarea--dark) {
        &:disabled {
            background-color: rgba($moonlit-ocean, 0.5);
            border: 1px solid rgba($pewter, 0.25);
            color: $pewter;
        }
    }

    &--disabled {
        :deep(.uikit-textarea__label) {
            color: $steel;
        }

        :deep(.uikit-textarea__label--dark) {
            color: rgba($pewter, 0.85);
        }
    }
}
</style>
